import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';
import {NgIf, NgFor, AsyncPipe} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuTrigger, MatMenuModule} from '@angular/material/menu';
import {TranslateModule} from '@ngx-translate/core';
import {AttachmentType, Q9HtmlDecoderPipe} from '@q9elements/ui-kit/common';
import {last, get} from 'lodash';

import {
  ActivityDocSubTab,
  SidebarService
} from '../../../../editor-interface/sidebar/sidebar.service';
import {AttachmentsService} from '../../../../diagram-interaction/attachments/attachments.service';
import {EditorRegistryService} from '../../../mx-graph/editor/editor-registry.service';
import {AuthService} from '../../../../core/auth/auth.service';
import {
  DiagramJsonHandlerService,
  IActJson
} from '../../../../diagram-data/diagram-json-handler.service';
import {ModeDataService} from '../../../../editor-state/mode-data.service';
import {ActivityTabsInEditEnum} from '../shape.model';
import {UserGroupsFilterPipe} from '../../../helpers/user-groups-filter.pipe';
import {MatDrawerToggleResult} from '@angular/material/sidenav';

@Component({
  selector: 'app-org-model-link',
  templateUrl: './org-model-link.component.html',
  styleUrls: ['./org-model-link.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatMenuModule,
    NgFor,
    AsyncPipe,
    TranslateModule,
    UserGroupsFilterPipe,
    Q9HtmlDecoderPipe
  ]
})
export class OrgModelLinkComponent implements OnInit {
  orgModelsOpened = false;
  isProSpace: boolean;
  userGroups: string[] = [];

  @Input() source: IActJson;
  @ViewChild(MatMenuTrigger)
  private menuTrigger: MatMenuTrigger;

  constructor(
    private sidebarSvc: SidebarService,
    private attachmentsSvc: AttachmentsService,
    private authSvc: AuthService,
    private diagramJsonSvc: DiagramJsonHandlerService,
    private registry: EditorRegistryService,
    public modeData: ModeDataService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.userGroups = get(this.authSvc.getUserDataSync(), 'userInTeam.groups', []);
    this.isProSpace = this.diagramJsonSvc.isPro();
  }

  openAttachments(): Promise<MatDrawerToggleResult> {
    return this.openRsbAndTab(ActivityTabsInEditEnum.DOCUMENTATIONS, ActivityDocSubTab.METADATA);
  }

  private openRsbAndTab(tab: number, subTab: ActivityDocSubTab): Promise<MatDrawerToggleResult> {
    this.sidebarSvc.refresh(this.source.mxKey, tab, subTab);

    return this.sidebarSvc.rightSidebar.open();
  }

  public openSingleAttachment(attachment) {
    const graph = this.registry.getGraph();

    attachment = this.prepareAttachment(attachment, AttachmentType.ORG_NODE);

    this.attachmentsSvc.openAttachment(
      graph.model.getCell(this.source.mxKey),
      attachment,
      AttachmentType.ORG_NODE
    );
  }

  private prepareAttachment(attachment, type: AttachmentType) {
    return {
      ...attachment,
      _id: String(attachment.mxKey || attachment.id),
      attachmentName: attachment.title,
      type
    };
  }

  openMenu() {
    // workaround to move context menu left
    const className = 'cdk-overlay-connected-position-bounding-box';
    const menus = document.getElementsByClassName(className) as HTMLCollection;
    const targetMenu = last(menus) as HTMLElement;

    if (!targetMenu) {
      return;
    }

    targetMenu.style.left = targetMenu.offsetLeft + 20 + 'px';
    this.orgModelsOpened = true;
    this.menuTrigger.openMenu();
  }

  onMenuClose() {
    setTimeout(() => {
      this.orgModelsOpened = false;
      this.cd.detectChanges();
    }, 400);
  }

  track(index, item) {
    return item.id;
  }
}
